import userQueries from '@apis/queries/userQueries';
import Loading from '@components/Loading';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { useQueryClient } from '@tanstack/react-query';
import { pushPendingPurchase } from '@utils/pendingPurchaseUtils';
import { setIsPrepaidCardBalanceUpdated } from '@utils/prepaidCardUtils';
import { useEffect } from 'react';

interface Params {
    cardId: string;
}

declare module '@stackflow/config' {
    interface Register {
        PrepaidCardOrderCompleteActivity: Params;
    }
}

// 외부 결제 페이지에서 처음 진입하므로 스택을 메인 → 내 선불카드로 다시 쌓는다.
const PrepaidCardOrderCompleteActivity: ActivityComponentType<'PrepaidCardOrderCompleteActivity'> = () => {
    const { replace, push } = useFlow();
    const queryClient = useQueryClient();
    useEffect(() => {
        pushPendingPurchase('PREPAID_CARD_PURCHASE');
        setIsPrepaidCardBalanceUpdated(true);
        queryClient.invalidateQueries({ queryKey: userQueries.assets().queryKey });
        replace('MainActivity', {}, { animate: false });
        push('MyPrepaidCardActivity', {});
    }, []);
    return (
        <AppScreen>
            <Loading />
        </AppScreen>
    );
};

export default PrepaidCardOrderCompleteActivity;
